import React from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch, Route } from 'react-router-dom';
import { IHasPageChangeRef } from '../../../../../../../main/interface/has-page-change';
import { useSetFourthLevelRoute } from '../../../../../../hooks/use-set-fourth-level-route';
import TaskViewContainer from './task-view-container';

interface IMatch {
  path: string;
  params: {
    thirdLevelRoute: string;
  }
}

interface ITaskViewProps {
  type: string;
  hasPageChangeRef: React.MutableRefObject<IHasPageChangeRef>;
}

class TaskView {

  name = 'task-view';

  render: React.FC<ITaskViewProps> = (props) => {
    const match: IMatch = useRouteMatch();
    const dispatch = useDispatch();

    useSetFourthLevelRoute({
      dispatch,
      mainRoute: 'admin',
      subRoute: 'business-process',
      thirdLevelRoute: match.params.thirdLevelRoute,
      fourthLevelRoute: this.name,
      currentRoute: this.name
    });

    return (
      <>
        <Route path={`${match.path}`} exact>
          <TaskViewContainer hasPageChangeRef={props.hasPageChangeRef} />
        </Route>
      </>
    );
  }
}

export default TaskView;
